import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import { useDispatch } from 'react-redux';

import Form from '@gef-ui/form-material/Form';

import { changeSelectedFeedback, resetFeedbacks } from 'features/views/semaphore/actions';
import formDescriptorFn, {
	SEMAPHORE_FEEDBACK_DETAIL_FORM_NAME,
} from 'features/views/semaphore/semaphoreFeedbackDetailModal/form';

import Feedback from './Feedback';
import LastModified from './LastModified';
import NoteForm from './NoteForm';

export const SemaphoreFeedbackDetailModalBody = ({ record }) => {
	const dispatch = useDispatch();
	const { feedback } = record;

	useEffect(
		() => () => {
			dispatch(resetFeedbacks());
		},
		[dispatch],
	);

	return (
		<Stack spacing={3}>
			<LastModified date={feedback?.date} />
			<Feedback type="fullFeedback" record={record} onClickFn={changeSelectedFeedback} />
			<Form name={SEMAPHORE_FEEDBACK_DETAIL_FORM_NAME} formDescriptorFn={formDescriptorFn}>
				<NoteForm record={record} />
			</Form>
		</Stack>
	);
};

SemaphoreFeedbackDetailModalBody.propTypes = {
	record: PropTypes.object,
};

export default SemaphoreFeedbackDetailModalBody;
